"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7965],{

/***/ 47965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ disableTwofa; },
/* harmony export */   "$H": function() { return /* binding */ apiManualFiatSettlementRequestMpesa; },
/* harmony export */   "$K": function() { return /* binding */ apiPHPDeposit; },
/* harmony export */   "$Q": function() { return /* binding */ createOrderInvoice; },
/* harmony export */   "AI": function() { return /* binding */ apiGetCountryList; },
/* harmony export */   "By": function() { return /* binding */ apiFormSettlement; },
/* harmony export */   "CZ": function() { return /* binding */ apiSettlementRequestCode; },
/* harmony export */   "Cr": function() { return /* binding */ apiBecomeAnAgentForm; },
/* harmony export */   "Ct": function() { return /* binding */ apiGetUserApiKeys; },
/* harmony export */   "Dr": function() { return /* binding */ enableTwofa; },
/* harmony export */   "E2": function() { return /* binding */ apiSettlementEstimate; },
/* harmony export */   "Fx": function() { return /* binding */ resendEmailVerification; },
/* harmony export */   "Fy": function() { return /* binding */ payContactRequest; },
/* harmony export */   "GC": function() { return /* binding */ apiGetSupportedFiatCurrencies; },
/* harmony export */   "GW": function() { return /* binding */ apiNGNCurrencyPrice; },
/* harmony export */   "Hu": function() { return /* binding */ apiGetCountries; },
/* harmony export */   "IV": function() { return /* binding */ apiBankVerify; },
/* harmony export */   "In": function() { return /* binding */ apiDeleteContact; },
/* harmony export */   "Iq": function() { return /* binding */ apiGetBanks; },
/* harmony export */   "J": function() { return /* binding */ apiContactRequestForm; },
/* harmony export */   "Js": function() { return /* binding */ apiGetWalletAddress; },
/* harmony export */   "K2": function() { return /* binding */ apiDepositMpesa; },
/* harmony export */   "Mt": function() { return /* binding */ apiGetTransactions; },
/* harmony export */   "Pn": function() { return /* binding */ apiNGNDeposit; },
/* harmony export */   "RJ": function() { return /* binding */ apiGetOrders; },
/* harmony export */   "Rr": function() { return /* binding */ getPaymentsStats; },
/* harmony export */   "SC": function() { return /* binding */ apiGetContacts; },
/* harmony export */   "SF": function() { return /* binding */ apiMpesaEstimate; },
/* harmony export */   "Sc": function() { return /* binding */ apiGetWithdrawCurrencies; },
/* harmony export */   "Sy": function() { return /* binding */ apiNewInvoiceForm; },
/* harmony export */   "TG": function() { return /* binding */ apiResetPassword; },
/* harmony export */   "TL": function() { return /* binding */ apiSendSMSCodePHP; },
/* harmony export */   "Tq": function() { return /* binding */ apiNGNPaymentOptions; },
/* harmony export */   "WL": function() { return /* binding */ apiGetBanksAccounts; },
/* harmony export */   "ZH": function() { return /* binding */ apiGetAccounts; },
/* harmony export */   "ZP": function() { return /* binding */ apiForgetPassword; },
/* harmony export */   "Zk": function() { return /* binding */ apiResendOtp; },
/* harmony export */   "Zu": function() { return /* binding */ apiPHPWithdrawalEstimate; },
/* harmony export */   "_$": function() { return /* binding */ apiTwoFa; },
/* harmony export */   "_I": function() { return /* binding */ apiFiatSettlementOptions; },
/* harmony export */   "_N": function() { return /* binding */ apiGetCurrencyRatesKES; },
/* harmony export */   "a7": function() { return /* binding */ apiManualFiatSettlementRequestNGN; },
/* harmony export */   "aA": function() { return /* binding */ apiSendSMSCodeManuelFiatSettlement; },
/* harmony export */   "aK": function() { return /* binding */ apiManualFiatSettlementMpesaRequesCode; },
/* harmony export */   "as": function() { return /* binding */ apiKESCurrencyPrice; },
/* harmony export */   "av": function() { return /* binding */ apiManualPHPBankAccounts; },
/* harmony export */   "bT": function() { return /* binding */ apiGetCurrencyRatesNGN; },
/* harmony export */   "bk": function() { return /* binding */ apiGetOrderInvoices; },
/* harmony export */   "bo": function() { return /* binding */ apiManualFiatNGNSettlementOptions; },
/* harmony export */   "c1": function() { return /* binding */ apiFormDeposit; },
/* harmony export */   "cX": function() { return /* binding */ apiGetCurrencies; },
/* harmony export */   "d1": function() { return /* binding */ generateTwofa; },
/* harmony export */   "et": function() { return /* binding */ getUserProfile; },
/* harmony export */   "ew": function() { return /* binding */ requestRefundCode; },
/* harmony export */   "g8": function() { return /* binding */ payContactManually; },
/* harmony export */   "gp": function() { return /* binding */ apiGetTwoFaStatus; },
/* harmony export */   "hK": function() { return /* binding */ apiKesBankSettlementRequest; },
/* harmony export */   "jN": function() { return /* binding */ apiLoginWithPassword; },
/* harmony export */   "jt": function() { return /* binding */ apiManualFiatSettlementOptions; },
/* harmony export */   "kS": function() { return /* binding */ logout; },
/* harmony export */   "kb": function() { return /* binding */ apiPHPSettlement; },
/* harmony export */   "lA": function() { return /* binding */ getOrderStats; },
/* harmony export */   "lm": function() { return /* binding */ verifyEmail; },
/* harmony export */   "oH": function() { return /* binding */ apiManualFiatPHPSettlementOptions; },
/* harmony export */   "pj": function() { return /* binding */ getBlockchains; },
/* harmony export */   "pp": function() { return /* binding */ payContact; },
/* harmony export */   "pt": function() { return /* binding */ GenerateWalletAddress; },
/* harmony export */   "r1": function() { return /* binding */ apiLoginOtp; },
/* harmony export */   "r6": function() { return /* binding */ deleteContactAddress; },
/* harmony export */   "rd": function() { return /* binding */ apiSendSMSCodeNGNSettlement; },
/* harmony export */   "u5": function() { return /* binding */ requestRefund; },
/* harmony export */   "uM": function() { return /* binding */ apiManualFiatSettlementBankDeposit; },
/* harmony export */   "ur": function() { return /* binding */ apiFiatTransactionProofDoc; },
/* harmony export */   "vV": function() { return /* binding */ apiChangePassword; },
/* harmony export */   "wZ": function() { return /* binding */ apiUpdateContact; },
/* harmony export */   "yW": function() { return /* binding */ apiCreateContact; },
/* harmony export */   "zZ": function() { return /* binding */ apiSettlementRequest; },
/* harmony export */   "zr": function() { return /* binding */ apiGetRetailTransactions; }
/* harmony export */ });
/* unused harmony exports createInvoice, getInvoices, getInvoicesConfigs, apiGetAccountById, payContactManuallyRequest, recurrentJobRequest, recurrentJob, getRecurrentJobs, recurrentJobAction, apiSettlementRate, apiManualFiatSettlementEstimate, apiPHPWithdrawalRequestCode, apiFiatOptions, apiManualMpesaBankAcctOptions */
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getHeaders = function getHeaders() {
  var headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };
  var token = localStorage.getItem("token");

  if (token) {
    headers.Authorization = "Bearer ".concat(token);
  }

  return headers;
};

var buildQueryParams = function buildQueryParams(queryParams) {
  return queryParams ? new URLSearchParams(Object.keys(queryParams).reduce(function (acc, value) {
    return queryParams[value] ? _objectSpread(_objectSpread({}, acc), {}, (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, value, queryParams[value])) : acc;
  }, {})) : "";
};

var getUserProfile = function getUserProfile() {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/user/profile"), {
    headers: getHeaders()
  });
};
var generateTwofa = function generateTwofa() {
  return axios__WEBPACK_IMPORTED_MODULE_2___default()({
    url: "".concat("https://gateway.api.datamynt.com", "/api/v1/two-fa/generate"),
    method: "POST",
    headers: getHeaders()
  });
};
var GenerateWalletAddress = function GenerateWalletAddress(orgId, network, type) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default()({
    url: "".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/retail/generate/").concat(network, "/address/").concat(type),
    method: "POST",
    headers: getHeaders()
  });
};
var disableTwofa = function disableTwofa(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/two-fa/disable"), data, {
    headers: getHeaders()
  });
};
var enableTwofa = function enableTwofa(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/two-fa/enable"), data, {
    headers: getHeaders()
  });
};
var apiGetTwoFaStatus = function apiGetTwoFaStatus() {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/two-fa/status"), {
    headers: getHeaders()
  });
};
var logout = function logout(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/auth/logout"), data, {
    headers: getHeaders()
  });
};
var apiLoginWithPassword = function apiLoginWithPassword(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/auth/login"), data, {
    headers: getHeaders()
  });
};
var apiResendOtp = function apiResendOtp(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/email/resend/login/email-code"), data, {
    headers: getHeaders()
  });
};
var apiForgetPassword = function apiForgetPassword(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/password/forgot"), data, {
    headers: getHeaders()
  });
};
var apiResetPassword = function apiResetPassword(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/password/reset"), data, {
    headers: getHeaders()
  });
};
var apiChangePassword = function apiChangePassword(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/password/change"), data, {
    headers: getHeaders()
  });
};
var verifyEmail = function verifyEmail(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/email/verification/approve"), data, {
    headers: getHeaders()
  });
};
var resendEmailVerification = function resendEmailVerification(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/email/verification/request"), data, {
    headers: getHeaders()
  });
};
var apiLoginOtp = function apiLoginOtp(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/email/verify/login/email-code"), data, {
    headers: getHeaders()
  });
};
var apiTwoFa = function apiTwoFa(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/auth/login/two-fa"), data, {
    headers: getHeaders()
  });
};
var apiGetWithdrawCurrencies = function apiGetWithdrawCurrencies(orgId) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/withdrawal/currencies/"), {
    headers: getHeaders()
  });
};
var apiGetCurrencies = function apiGetCurrencies(apiKey) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/sell/currencies/").concat(apiKey), {
    headers: getHeaders()
  });
};
var getBlockchains = function getBlockchains() {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/blockchains/"), {
    headers: getHeaders()
  });
};
var createInvoice = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(orgId, data) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", axios.post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/user-invoice"), data, {
              headers: getHeaders()
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createInvoice(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()));
var createOrderInvoice = /*#__PURE__*/function () {
  var _ref2 = (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(orgId, data) {
    return _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/order/invoice"), data, {
              headers: getHeaders()
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createOrderInvoice(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var getInvoices = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(orgId, page, perPage, queryParams) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", axios.get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/user-invoices/").concat(page, "/").concat(perPage, "?").concat(buildQueryParams(queryParams)), {
              headers: getHeaders()
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getInvoices(_x5, _x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}()));
var getInvoicesConfigs = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", axios.get("".concat("https://gateway.api.datamynt.com", "/api/v1/user-invoices-configs"), {
              headers: getHeaders()
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getInvoicesConfigs() {
    return _ref4.apply(this, arguments);
  };
}()));
var apiGetAccounts = function apiGetAccounts(orgId) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/accounts/1/10"), {
    headers: getHeaders()
  });
};
var apiGetAccountById = function apiGetAccountById(orgId, accountId) {
  return axios.get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/account/").concat(accountId), {
    headers: getHeaders()
  });
};
var apiGetWalletAddress = function apiGetWalletAddress(orgId, type) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/retail/address/").concat(type), {
    headers: getHeaders()
  });
};
var apiGetTransactions = function apiGetTransactions(orgId, accountId, page, perPage, queryParams) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/accounts/transactions/").concat(page, "/").concat(perPage, "?").concat(buildQueryParams(queryParams)), {
    headers: getHeaders()
  });
};
var apiGetOrderInvoices = function apiGetOrderInvoices(orgId, page, perPage, queryParams) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v3/org/").concat(orgId, "/order/invoices/").concat(page, "/").concat(perPage, "?").concat(buildQueryParams(queryParams)), {
    headers: getHeaders()
  });
};
var apiGetContacts = function apiGetContacts(orgId, page, perPage, queryParams) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/contacts").concat(page && perPage ? "/".concat(page, "/").concat(perPage) : "", "?").concat(buildQueryParams(queryParams)), {
    headers: getHeaders()
  });
};
var apiGetUserApiKeys = function apiGetUserApiKeys(orgId, page, perPage) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/api/keys").concat(page && perPage ? "/".concat(page, "/").concat(perPage) : ""), {
    headers: getHeaders()
  });
};
var apiGetCountries = function apiGetCountries(query, page, perPage) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/countries?").concat(query ? "search=".concat(query) : "").concat(page && perPage ? "&page_number=".concat(page, "&per_page=").concat(perPage) : ""), {
    headers: getHeaders()
  });
};
var apiCreateContact = function apiCreateContact(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/contacts/add"), data, {
    headers: getHeaders()
  });
};
var apiUpdateContact = function apiUpdateContact(orgId, id, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().patch("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/contacts/").concat(id, "/update"), data, {
    headers: getHeaders()
  });
};
var apiDeleteContact = function apiDeleteContact(orgId, id) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default()["delete"]("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/contacts/").concat(id, "/remove"), {
    headers: getHeaders()
  });
};
var payContactRequest = function payContactRequest(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/account/wallet-withdrawal/request-code"), data, {
    headers: getHeaders()
  });
};
var payContactManuallyRequest = function payContactManuallyRequest(orgId, data) {
  return axios.post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/account/manual-withdrawal-request/request-code"), data, {
    headers: getHeaders()
  });
};
var payContact = function payContact(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/account/wallet-withdrawal/request"), data, {
    headers: getHeaders()
  });
};
var payContactManually = function payContactManually(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/account/manual-withdrawal-request"), data, {
    headers: getHeaders()
  });
};
var deleteContactAddress = function deleteContactAddress(orgId, contactId, contactAddressId, deleteOnlyAddress) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default()["delete"]("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/contacts/").concat(contactId, "/remove?").concat(new URLSearchParams({
    contactAddressId: contactAddressId,
    deleteOnlyAddress: deleteOnlyAddress
  })), {
    headers: getHeaders()
  });
};
var recurrentJobRequest = function recurrentJobRequest(orgId, data) {
  return axios.post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/recurring/job/request"), data, {
    headers: getHeaders()
  });
};
var recurrentJob = function recurrentJob(orgId, data) {
  return axios.post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/recurring/job/new"), data, {
    headers: getHeaders()
  });
};
var getRecurrentJobs = function getRecurrentJobs(orgId, page, perPage, queryParams) {
  return axios.get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/recurring/jobs/list/").concat(page, "/").concat(perPage, "?").concat(buildQueryParams(queryParams)), {
    headers: getHeaders()
  });
};
var recurrentJobAction = function recurrentJobAction(orgId, rcOpId, options) {
  return axios.post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/recurring/job/").concat(rcOpId, "/action?terminate=").concat(!!options.terminate, "&on_hold=").concat(!!options.onHold, "&active=").concat(!!options.active, "&updateTx=").concat(!!options.updateTx), {}, {
    headers: getHeaders()
  });
};
var apiGetRetailTransactions = function apiGetRetailTransactions(orgId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var type = arguments.length > 3 ? arguments[3] : undefined;
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/retail/transactions/").concat(page, "/").concat(perPage).concat(type ? "?type=".concat(type) : ""), {
    headers: getHeaders()
  });
};
var getOrderStats = function getOrderStats(orgId, fromDate, toDate) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/stats/orders?").concat(fromDate && toDate ? "fromDate=".concat(fromDate, "&toDate=").concat(toDate) : ""), {
    headers: getHeaders()
  });
};
var getPaymentsStats = function getPaymentsStats(orgId, fromDate, toDate) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/stats/settlement?").concat(fromDate && toDate ? "fromDate=".concat(fromDate, "&toDate=").concat(toDate) : ""), {
    headers: getHeaders()
  });
};
var apiGetOrders = function apiGetOrders(orgId, pageNumber, perPage, queryParams) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/orders/").concat(pageNumber && perPage ? "".concat(pageNumber, "/").concat(perPage) : "", "?").concat(buildQueryParams(queryParams)), {
    headers: getHeaders()
  });
};
var requestRefundCode = function requestRefundCode(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/refund/request-code"), data, {
    headers: getHeaders()
  });
};
var requestRefund = function requestRefund(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/refund/request"), data, {
    headers: getHeaders()
  });
};
var apiGetBanks = function apiGetBanks(orgId) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/fiat-settlement/yellow-card/banks"), {
    headers: getHeaders()
  });
};
var apiGetBanksAccounts = function apiGetBanksAccounts(orgId, pageNumber, perPage, queryParams) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/fiat-settlement/bank-accounts/").concat(pageNumber && perPage ? "".concat(pageNumber, "/").concat(perPage) : "", "?").concat(buildQueryParams(queryParams)), {
    headers: getHeaders()
  });
};
var apiBankVerify = function apiBankVerify(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/fiat-settlement/verify/bank"), data, {
    headers: getHeaders()
  });
};
var apiSettlementRate = function apiSettlementRate(orgId) {
  return axios.get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/fiat-settlement/rate"), {
    headers: getHeaders()
  });
};
var apiSettlementEstimate = function apiSettlementEstimate(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/fiat-settlement/estimate"), data, {
    headers: getHeaders()
  });
};
var apiSettlementRequestCode = function apiSettlementRequestCode(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/fiat-settlement/request-code"), data, {
    headers: getHeaders()
  });
};
var apiSettlementRequest = function apiSettlementRequest(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/fiat-settlement/request"), data, {
    headers: getHeaders()
  });
};
var apiFiatSettlementOptions = function apiFiatSettlementOptions(orgId, pageNumber, perPage, queryParams) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/fiat-settlement/payment-options/").concat(pageNumber && perPage ? "".concat(pageNumber, "/").concat(perPage) : "", "?").concat(buildQueryParams(queryParams)), {
    headers: getHeaders()
  });
};
var apiFormDeposit = function apiFormDeposit(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/form/deposit"), data, {
    headers: getHeaders()
  });
};
var apiFormSettlement = function apiFormSettlement(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/form/settlement"), data, {
    headers: getHeaders()
  });
};
var apiContactRequestForm = function apiContactRequestForm(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/form/contact"), data, {
    headers: getHeaders()
  });
};
var apiManualFiatSettlementEstimate = function apiManualFiatSettlementEstimate(orgId, data) {
  return axios.post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/manual-fiat-settlement/estimate"), data, {
    headers: getHeaders()
  });
};
var apiSendSMSCodeManuelFiatSettlement = function apiSendSMSCodeManuelFiatSettlement(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/mpesa-fiat-settlement/request-code"), data, {
    headers: getHeaders()
  });
};
var apiSendSMSCodeNGNSettlement = function apiSendSMSCodeNGNSettlement(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/request-code"), data, {
    headers: getHeaders()
  });
};
var apiManualFiatSettlementRequestMpesa = function apiManualFiatSettlementRequestMpesa(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/mpesa-fiat-settlement/request"), data, {
    headers: getHeaders()
  });
};
var apiManualFiatSettlementRequestNGN = function apiManualFiatSettlementRequestNGN(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/request"), data, {
    headers: getHeaders()
  });
};
var apiBecomeAnAgentForm = function apiBecomeAnAgentForm(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/form/agent"), data, {
    headers: getHeaders()
  });
};
var apiDepositMpesa = function apiDepositMpesa(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/mpesa-fiat-settlement/deposit/request"), data, {
    headers: getHeaders()
  });
};
var apiNewInvoiceForm = function apiNewInvoiceForm(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/order/invoice"), data, {
    headers: getHeaders()
  });
};
var apiManualFiatPHPSettlementOptions = function apiManualFiatPHPSettlementOptions(orgId) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var queryParams = arguments.length > 3 ? arguments[3] : undefined;
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/payment-options/").concat(pageNumber, "/").concat(perPage), {
    headers: getHeaders()
  });
};
var apiManualFiatNGNSettlementOptions = function apiManualFiatNGNSettlementOptions(orgId) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var queryParams = arguments.length > 3 ? arguments[3] : undefined;
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/payment-options/").concat(pageNumber, "/").concat(perPage), {
    headers: getHeaders()
  });
};
var apiManualPHPBankAccounts = function apiManualPHPBankAccounts(orgId) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/bank-accounts/").concat(pageNumber, "/").concat(perPage), {
    headers: getHeaders()
  });
};
var apiGetCountryList = function apiGetCountryList() {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/countries"), {
    headers: getHeaders()
  });
};
var apiPHPDeposit = function apiPHPDeposit(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/php-fiat-settlement/deposit/request"), data, {
    headers: getHeaders()
  });
};
var apiPHPSettlement = function apiPHPSettlement(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/request"), data, {
    headers: getHeaders()
  });
};
var apiPHPWithdrawalEstimate = function apiPHPWithdrawalEstimate(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/estimate"), data, {
    headers: getHeaders()
  });
};
var apiPHPWithdrawalRequestCode = function apiPHPWithdrawalRequestCode(orgId, data) {
  return axios.post("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/php-fiat-settlement/request-code"), data, {
    headers: getHeaders()
  });
};
var apiSendSMSCodePHP = function apiSendSMSCodePHP(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/request-code"), data, {
    headers: getHeaders()
  });
};
var apiManualFiatSettlementMpesaRequesCode = function apiManualFiatSettlementMpesaRequesCode(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/request-code"), data, {
    headers: getHeaders()
  });
};
var apiNGNPaymentOptions = function apiNGNPaymentOptions(orgId) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var queryParams = arguments.length > 3 ? arguments[3] : undefined;
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/payment-options/").concat(pageNumber, "/").concat(perPage), {
    headers: getHeaders()
  });
};
var apiFiatOptions = function apiFiatOptions(orgId) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var queryParams = arguments.length > 3 ? arguments[3] : undefined;
  return axios.get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/payment-options/").concat(pageNumber, "/").concat(perPage), {
    headers: getHeaders()
  });
};
var apiNGNDeposit = function apiNGNDeposit(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/deposit/request"), data, {
    headers: getHeaders()
  });
};
var apiNGNCurrencyPrice = function apiNGNCurrencyPrice(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/currency/price/usdc/ngn"), data, {
    headers: getHeaders()
  });
};
var apiKESCurrencyPrice = function apiKESCurrencyPrice(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/currency/price/usdc/kes"), data, {
    headers: getHeaders()
  });
};
var apiKesBankSettlementRequest = function apiKesBankSettlementRequest(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/request"), data, {
    headers: getHeaders()
  });
};
var apiManualFiatSettlementBankDeposit = function apiManualFiatSettlementBankDeposit(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/deposit/request"), data, {
    headers: getHeaders()
  });
};
var apiManualMpesaBankAcctOptions = function apiManualMpesaBankAcctOptions(orgId) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var queryParams = arguments.length > 3 ? arguments[3] : undefined;
  return axios.get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/bank-accounts/").concat(pageNumber, "/").concat(perPage), {
    headers: getHeaders()
  });
};
var apiManualFiatSettlementOptions = function apiManualFiatSettlementOptions(orgId) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var queryParams = arguments.length > 3 ? arguments[3] : undefined;
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/manual-fiat-settlement/payment-options/").concat(pageNumber, "/").concat(perPage), {
    headers: getHeaders()
  });
};
var apiGetSupportedFiatCurrencies = function apiGetSupportedFiatCurrencies(orgId) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/org/").concat(orgId, "/currency/supported-fiat-currencies"), {
    headers: getHeaders()
  });
};
var apiFiatTransactionProofDoc = function apiFiatTransactionProofDoc(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/fiat-settlement/upload/transaction-proof/document"), data, {
    headers: getHeaders()
  });
};
var apiGetCurrencyRatesNGN = function apiGetCurrencyRatesNGN(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/currency/price/usdc/ngn"), data, {
    headers: getHeaders()
  });
};
var apiGetCurrencyRatesKES = function apiGetCurrencyRatesKES(data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://gateway.api.datamynt.com", "/api/v1/currency/price/usdc/kes"), data, {
    headers: getHeaders()
  });
};
var apiMpesaEstimate = function apiMpesaEstimate(orgId, data) {
  return axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://gateway.api.datamynt.com", "/api/v2/org/").concat(orgId, "/mpesa-fiat-settlement/estimate"), data, {
    headers: getHeaders()
  });
};

/***/ })

}]);